import { ResellerLevel } from "../constants";

export const getResellerLevelLabelText = (level: ResellerLevel) => {
  switch (level) {
    case ResellerLevel.Buyer:
      return "Buyer";
    case ResellerLevel.IncompleteReseller:
      return "Reseller";
    case ResellerLevel.BeginnerReseller:
      return "Beginner Reseller";
    case ResellerLevel.IntermediateReseller:
      return "Intermediate Reseller";
    case ResellerLevel.ConfirmedReseller:
      return "Confirmed Reseller";
    case ResellerLevel.Influencer:
      return "Influencer";
    default:
      return "Unknown level";
  }
};
